export class ApiError extends Error {
  constructor(
    message: string,
    readonly status: number,
    readonly code?: string,
  ) {
    super(message);
  }
}

export function errorMessage(caught: unknown, fallback: string): string {
  return caught instanceof Error ? caught.message : fallback;
}

export async function api<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(path, {
    credentials: "same-origin",
    ...init,
    headers: {
      ...(init?.body ? { "Content-Type": "application/json" } : {}),
      ...init?.headers,
    },
  });
  const data = response.headers.get("content-type")?.includes("json")
    ? ((await response.json()) as T & {
        error?: string;
        message?: string;
        error_description?: string;
      })
    : undefined;
  // A body-less or non-JSON reply is a gateway-level fault even on a 2xx, and
  // must not be reported under a status that reads as a successful request.
  if (!data) {
    throw new ApiError(
      "The server returned an unexpected response.",
      response.ok ? 502 : response.status,
    );
  }
  if (!response.ok) {
    throw new ApiError(
      data.message ??
        data.error_description ??
        "The request could not be completed.",
      response.status,
      data.error,
    );
  }
  return data;
}
